/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSimulationProductMutation from '../graphql/mutations/SaveSimulationProductMutation.js';

export const useSaveSimulationProductMutation = () => {
  return useCommitMutation(SaveSimulationProductMutation, {
    dataProp: 'saveSimulationProduct_M_simulation_product'
  });
};

export default useSaveSimulationProductMutation;
